/**
 * Editorial map: each article slug → 3 related article slugs.
 * Used by <RelatedArticles> to render contextually relevant links.
 */
export const RELATED_MAP = {
  'costo-de-vida-montreal-2026': [
    'construir-credito-canada-desde-cero',
    'mejores-cuentas-sin-fees-recien-llegados',
    'tfsa-vs-rrsp-vs-fhsa-inmigrantes',
  ],
  'construir-credito-canada-desde-cero': [
    'tarjetas-newcomers-que-piden-bancos',
    'mejores-cuentas-sin-fees-recien-llegados',
    'costo-de-vida-montreal-2026',
  ],
  'tfsa-vs-rrsp-vs-fhsa-inmigrantes': [
    'primera-hipoteca-canada-guia',
    'rrsp-deadline-marzo-2026',
    'guia-impuestos-latinos-quebec-2026',
  ],
  'primera-hipoteca-canada-guia': [
    'tfsa-vs-rrsp-vs-fhsa-inmigrantes',
    'construir-credito-canada-desde-cero',
    'costo-de-vida-montreal-2026',
  ],
  'mejores-cuentas-sin-fees-recien-llegados': [
    'construir-credito-canada-desde-cero',
    'tarjetas-newcomers-que-piden-bancos',
    'tfsa-vs-rrsp-vs-fhsa-inmigrantes',
  ],
  'guia-impuestos-latinos-quebec-2026': [
    'tfsa-vs-rrsp-vs-fhsa-inmigrantes',
    't4-explicado-espanol-impuestos-canada',
    'cra-vs-revenu-quebec-diferencias',
  ],
  't4-explicado-espanol-impuestos-canada': [
    'guia-impuestos-latinos-quebec-2026',
    'cra-vs-revenu-quebec-diferencias',
    'solidarity-tax-credit-quebec-guia-completa',
  ],
  'cra-vs-revenu-quebec-diferencias': [
    'guia-impuestos-latinos-quebec-2026',
    't4-explicado-espanol-impuestos-canada',
    'solidarity-tax-credit-quebec-guia-completa',
  ],
  'rrsp-deadline-marzo-2026': [
    'tfsa-vs-rrsp-vs-fhsa-inmigrantes',
    'guia-impuestos-latinos-quebec-2026',
    'primera-hipoteca-canada-guia',
  ],
  'solidarity-tax-credit-quebec-guia-completa': [
    'guia-impuestos-latinos-quebec-2026',
    'cra-vs-revenu-quebec-diferencias',
    'credito-solidaridad-quebec-inmigrantes',
  ],
  'tarjetas-newcomers-que-piden-bancos': [
    'construir-credito-canada-desde-cero',
    'mejores-cuentas-sin-fees-recien-llegados',
    'costo-de-vida-montreal-2026',
  ],
  'errores-financieros-recien-llegados-canada': [
    'construir-credito-canada-desde-cero',
    'costo-de-vida-montreal-2026',
    'mejores-cuentas-sin-fees-recien-llegados',
  ],
  'enviar-dinero-latinoamerica-canada': [
    'costo-de-vida-montreal-2026',
    'mejores-cuentas-sin-fees-recien-llegados',
    'construir-credito-canada-desde-cero',
  ],
  'credito-solidaridad-quebec-inmigrantes': [
    'solidarity-tax-credit-quebec-guia-completa',
    'guia-impuestos-latinos-quebec-2026',
    'cra-vs-revenu-quebec-diferencias',
  ],
};
